import { render } from "./PhoneCallListBlock.vue?vue&type=template&id=42778ec8"
import script from "./PhoneCallListBlock.vue?vue&type=script&lang=js"
export * from "./PhoneCallListBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__